import { render, staticRenderFns } from "./FiltersBox.vue?vue&type=template&id=07c7d4b6&scoped=true"
import script from "./FiltersBox.vue?vue&type=script&lang=js"
export * from "./FiltersBox.vue?vue&type=script&lang=js"
import style0 from "./FiltersBox.vue?vue&type=style&index=0&id=07c7d4b6&prod&lang=stylus&scoped=true"
import style1 from "./FiltersBox.vue?vue&type=style&index=1&id=07c7d4b6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c7d4b6",
  null
  
)

export default component.exports